import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';
import { UsersService } from '../../users-service/users.service';
import { GrpcStatusEvent } from '@ngx-grpc/common';
import { GetUserRequest } from '../../../../protos/generated/admin.pb';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-user-disable',
    imports: [MatButtonModule, MatDialogModule, TranslatePipe],
    templateUrl: './confirm-user-disable.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './confirm-user-disable.component.scss'
})
export class ConfirmUserDisableComponent {
    isloading: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private usersService: UsersService,
        public dialogRef: MatDialogRef<ConfirmUserDisableComponent>
    ) {}

    disableUser() {
        this.isloading = true;
        const request = new GetUserRequest({ id: this.data.id });
        this.usersService.disableUser(request).subscribe({
            next: () => {
                this.usersService.notifyUserDisabledStatusChange();
                this.dialogRef.close(true);
                this.isloading = false;
            },
            error: (error: GrpcStatusEvent) => {
                console.error(error.statusMessage);
                this.isloading = false;
            }
        });
    }

    enableUser() {
        this.isloading = true;
        const request = new GetUserRequest({ id: this.data.id });
        this.usersService.enableUser(request).subscribe({
            next: () => {
                this.usersService.notifyUserDisabledStatusChange();
                this.dialogRef.close(true);
                this.isloading = false;
            },
            error: (error: GrpcStatusEvent) => {
                console.error(error.statusMessage);
                this.isloading = false;
            }
        });
    }
}
